import React from 'react';
import {useTranslation} from 'react-i18next';
import {Alert} from '@taopix/taopix-design-system';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Context/UserInterface/UserInterfaceActionTypes';
import {DialogStatus} from '../../../Enums';

type ProjectLayoutChangeNotificationProps = {
  open: boolean;
};

const ProjectLayoutChangeNotification = ({open}: ProjectLayoutChangeNotificationProps) => {
  const {t} = useTranslation();
  const ui = useUiState();

  const closeDialog = () => {
    ui.dispatch(
      UserInterfaceActions.setDialogStatus({projectLayoutChangeNotification: DialogStatus.Seen})
    );
  };

  return (
    <Alert
      id={'project-layout-change-notification'}
      open={open}
      type={'warning'}
      message={t('str_MessageWizardProjectLayoutChanged')}
      onClose={closeDialog}
    />
  );
};

export default ProjectLayoutChangeNotification;
